// ── NotifLayer ────────────────────────────────────────────────────────────────
// The event/condition-driven toast rail + celebration listeners, gathered behind
// ONE lazy boundary — mirrors CinematicLayer's rationale exactly (perf audit
// 2026-08-15 follow-up): these eleven components rode the 96.6KB gz entry chunk
// statically, ~78KB raw / ~26KB gz of code for moments that can't fire before a
// user has done something (marked watched, unlocked an achievement, hit a save
// error, it's their birthday). Moving them here cuts the entry chunk by roughly
// a quarter with the same safety argument CinematicLayer already documents: App
// mounts this inside <Suspense fallback={null}> right after hydration, so the
// chunk is in flight before any of these listeners could plausibly be needed.
//
// NOT HERE: isOverlayBusy()/CELEBRATION_RAIL_ID moved to lib/overlayBusy.js
// specifically so components that need it SYNCHRONOUSLY (ActivityToastStack,
// which is NOT lazy) don't pull this whole layer in transitively. Celebration.jsx
// re-exports both for existing importers — see that file's header.
//
// Render position doesn't matter: every component here is either createPortal'd
// or a bare position:fixed div, so moving them from their old split locations
// (some lived in AppRoutes pre-<Routes>, some in the outer App return) into one
// mount point changes nothing visually. Verified live 2026-08-15.
import { CelebrationListener } from './Celebration'
import { AchievementUnlockListener } from './AchievementUnlock'
import { StreakMilestoneListener } from './StreakMilestone'
import { BirthdayCelebration } from './BirthdayCelebration'
import { EpisodeBurstListener } from './EpisodeBurst'
import { RatingSavedToast } from './RatingSavedToast'
import { ReviewInvite } from './ReviewInvite'
import { SaveErrorToast } from './SaveErrorToast'
import { UndoToast } from './UndoToast'
import { BatchReceipt } from './BatchReceipt'
import { AdminFab } from './AdminFab'
import { WatchReturnPrompt } from './WatchReturnPrompt'
import { WatchingCheckIn } from './WatchingCheckIn'
import { NotificationNudge } from './NotificationNudge'
import { SeasonWrapHost } from './SeasonWrap'
import { ErrorBoundary } from './ErrorBoundary'

export default function NotifLayer({ user, profile, wl }) {
  return (
    <>
      <SaveErrorToast />
      <CelebrationListener />
      <AchievementUnlockListener />
      <StreakMilestoneListener />
      <BirthdayCelebration profile={profile} />
      <EpisodeBurstListener />
      <RatingSavedToast />
      <UndoToast />
      {/* One sheet for a cascade mark's whole pile of toasts (2026-09-22). */}
      <BatchReceipt />
      {user && <ErrorBoundary label="admin fab" fallback={null}><AdminFab user={user} /></ErrorBoundary>}
      <WatchReturnPrompt wl={wl} user={user} />
      <WatchingCheckIn user={user} wl={wl} />
      {/* Push ask at the first mark — was unmounted by the v17 Home rebuild (2026-09-21). */}
      <NotificationNudge user={user} />
      <SeasonWrapHost />
      <ReviewInvite user={user} profile={profile} />
    </>
  )
}
